module.exports = __webpack_public_path__ + "static/media/classes.90990488.png";